class TakeoverDesktop {
    constructor(element) {
        this.element = element;

        this.headerElement = document.querySelector(".js-header");
        this.footerElement = document.querySelector(".js-footer");
        this.mainContentsElement = document.querySelector(".js-main__contents");

        this.mainElement = this.element.querySelector(".js-takeover__main");
        this.sideElements = [...this.element.querySelectorAll(".js-takeover__side")];
    }

    calculateOverlappedHeight() {
        const { scrollY } = window;
        const bodyHeight = document.body.clientHeight;
        const footerHeight = this.footerElement.clientHeight;
        const sideMaxHeight = Math.max(
            ...this.sideElements.map((sideElement) => sideElement.clientHeight)
        );

        return scrollY + sideMaxHeight - (bodyHeight - footerHeight);
    }

    calculatePositionSideTop() {
        const { scrollY, innerHeight } = window;
        const headerHeight = this.headerElement.clientHeight;
        const sideMaxHeight = Math.max(
            ...this.sideElements.map((sideElement) => sideElement.clientHeight)
        );
        const targetVerticalHeight = Math.max(innerHeight, sideMaxHeight);

        const { top: footerElementY } = this.footerElement.getBoundingClientRect();
        const targetScrollY = footerElementY - targetVerticalHeight;
        if (targetScrollY < 0) {
            return targetScrollY;
        }

        if (scrollY < headerHeight) {
            return headerHeight - scrollY;
        }

        return 0;
    }

    calculatePositionMainTop() {
        const { scrollY } = window;
        const headerHeight = this.headerElement.clientHeight;

        const { top: mainElementY } = this.mainContentsElement.getBoundingClientRect();
        let targetScrollY = mainElementY;

        const pickupArticlesElement = this.mainContentsElement.querySelector(".js-pickup-articles");
        if (pickupArticlesElement) {
            targetScrollY += pickupArticlesElement.offsetHeight;
        }

        if (targetScrollY < 0) {
            return targetScrollY;
        }

        if (scrollY < headerHeight) {
            return headerHeight - scrollY;
        }

        return 0;
    }

    setMainContentsPadding() {
        const sideMaxHeight = Math.max(
            ...this.sideElements.map((sideElement) => sideElement.clientHeight)
        );
        const mainDiv = this.mainContentsElement.closest(".main");
        const mainSectionHeight = mainDiv.clientHeight;
        this.mainContentsElement.style.paddingTop = `${this.mainElement.clientHeight}px`;
        const paddingBottomValue = Math.max(sideMaxHeight - mainSectionHeight, 0);
        if (paddingBottomValue > 0) {
            this.mainContentsElement.style.paddingBottom = `${paddingBottomValue}px`;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    setBodyMargin() {
        document.body.style.marginTop = 0;
        document.body.style.marginBottom = 0;
    }

    reposition() {
        const sideTop = this.calculatePositionSideTop();
        const mainTop = this.calculatePositionMainTop();

        this.setMainContentsPadding();
        this.setBodyMargin();

        this.mainElement.style.top = `${mainTop}px`;
        this.sideElements.forEach((sideElement) => {
            // eslint-disable-next-line no-param-reassign
            sideElement.style.top = `${sideTop}px`;
        });
    }
}

export { TakeoverDesktop };
